import React from 'react';

const CampaignsTableSkeleton = () => {
  const numberOfRows = 5;
  // 12 columnas: checkbox, Plataforma, Entidad, Gasto, Conv., CPA, ROAS, Clics, CPC, CTR, Impr., CPM
  const columnsConfig = [
    { headerWidth: 'w-10', bodyWidth: 'w-6', bodyHeight: 'h-6', align: 'center' },
    { headerWidth: 'w-20', bodyWidth: 'w-16', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-32', bodyWidth: 'w-40', bodyHeight: 'h-4', align: 'left' },
    { headerWidth: 'w-16', bodyWidth: 'w-16', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-16', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-16', bodyHeight: 'h-4', align: 'center' },
    { headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', align: 'center' }
  ];

  return (
    <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl hover:bg-gradient-to-br hover:from-slate-700/90 hover:via-slate-800/90 hover:to-indigo-800/90 hover:border-white/30 transition-all duration-500 ease-out mt-12 mx-0">
      <div className="relative z-10">
        {/* Tabs skeleton - igual que CampaignsWithImpressionsTable */}
        <div
          role="tablist"
          className="flex gap-1 mb-4 p-1 rounded-lg bg-white/5 border border-white/10"
        >
          {['Campañas', 'Grupos de anuncios', 'Anuncios'].map((label, i) => (
            <div key={i} className="h-9 flex-1 bg-white/10 rounded-md animate-pulse" />
          ))}
        </div>
        {/* Header con título y botón descargar */}
        <div className="flex justify-between items-center mb-6">
          <div className="text-left">
            <div className="h-6 w-52 bg-white/20 rounded animate-pulse mb-2"></div>
            <div className="w-16 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full"></div>
          </div>
          <div className="h-10 w-28 bg-white/10 rounded-lg animate-pulse border border-white/20"></div>
        </div>
        
        {/* Table skeleton */}
        <div className="overflow-x-auto rounded-lg">
          <table className="w-full min-w-[800px]">
            <thead>
              <tr className="border-b border-white/30">
                {columnsConfig.map((column, index) => (
                  <th key={index} className={`${column.align === 'left' ? 'text-left' : 'text-center'} py-3 px-4`}>
                    <div className={`h-4 ${column.headerWidth} bg-white/20 rounded animate-pulse ${column.align === 'center' ? 'mx-auto' : ''}`}></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-white/20">
              {/* Skeleton rows */}
              {[...Array(numberOfRows)].map((_, rowIndex) => (
                <tr key={rowIndex} className="hover:bg-white/10 transition-colors">
                  {columnsConfig.map((column, colIndex) => (
                    <td key={colIndex} className={`py-4 px-4 ${column.align === 'left' ? 'text-left' : 'text-center'}`}>
                      <div className={`${column.bodyHeight} ${column.bodyWidth} bg-white/20 rounded animate-pulse ${column.align === 'center' ? 'mx-auto' : ''}`}></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CampaignsTableSkeleton;
